export default __webpack_public_path__ + "static/22-662525d1fea5fbd379a8697da0250a01.jpg";